import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Button,
  ConfigProvider,
  Form,
  Input,
  Space,
  Switch,
  Select,
} from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import 'moment-timezone';
import FormCoverUpload from 'modules/galleryModules/components/FormCoverUpload';
import { FieldData } from 'rc-field-form/lib/interface';
import { getProvincesRequest } from 'modules/sectionsModule/requests/sectionsRequests';
import { createRepresentativesRequest } from '../requests/contactRequests';

const RepresentativesAdd = (): JSX.Element => {
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [form] = Form.useForm();
  const [fileImage1, setFileImage1] = useState<string | null>(null);
  const [fileImage2, setFileImage2] = useState<string | null>(null);
  const [fields, setFields] = useState<FieldData[]>([]);
  const [provinces, setProvinces] = useState([]);

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  useEffect(() => {
    getProvincesRequest().then((response) => {
      if (response) {
        const sections = response.map(
          (section: { name: string; id: number }) => {
            return {
              label: section.name,
              value: section.id,
            };
          }
        );
        sections.unshift({ label: '', value: '' });
        setProvinces(sections);
      }
    });
  }, []);

  const onSubmitForm = (values: any) => {
    toggleButtonLoading(true);
    createRepresentativesRequest(values).then(() => toggleButtonLoading(false));
  };

  const updateCover = (
    e: string,
    field: string,
    coverMethod: (value: string) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Kontakt</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/representatives">Przedstawiciele terenowi</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/representatives/add">Dodaj</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <div className="site-layout-background">
        <ConfigProvider locale={plPL}>
          <Form
            layout="vertical"
            validateMessages={validateMessages}
            onFinish={onSubmitForm}
            form={form}
            fields={fields}
          >
            <Form.Item
              name="fileImage1"
              label="Avatar"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <FormCoverUpload
                cover={fileImage1}
                setCover={(e) => updateCover(e, 'fileImage1', setFileImage1)}
                isNew
                field="fileImage1"
                number={1}
                hideTags
                dontResize
              />
            </Form.Item>
            <Form.Item name="fileImage2" label="Grafika mapki">
              <FormCoverUpload
                cover={fileImage2}
                setCover={(e) => updateCover(e, 'fileImage2', setFileImage2)}
                isNew
                field="fileImage2"
                number={2}
                hideTags
                originalFile
              />
            </Form.Item>
            <Form.Item
              name="name"
              label="Imię i nazwisko"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="phone"
              label="Numer telefonu"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="email"
              label="Adres e-mail"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="idProvince1"
              label="Województwo 1"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Wybierz województwo"
                optionFilterProp="children"
                options={provinces}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item name="idProvince2" label="Województwo 2">
              <Select
                showSearch
                placeholder="Wybierz województwo"
                optionFilterProp="children"
                options={provinces}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item name="idProvince3" label="Województwo 3">
              <Select
                showSearch
                placeholder="Wybierz województwo"
                optionFilterProp="children"
                options={provinces}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
            <Form.Item
              name="sortOrder"
              label="Kolejność"
              rules={[
                {
                  required: true,
                },
                {
                  validator: async (_, value) => {
                    if (value) {
                      if (
                        (value.length > 5 ||
                          !/^[0-9]*\,?\.?[0-9]*$/.test(value)) &&
                        value.length > 0
                      ) {
                        return Promise.reject(
                          new Error('Proszę podać poprawną wartość!')
                        );
                      }
                    }
                  },
                },
              ]}
            >
              <Input
                style={{
                  width: '100px',
                }}
              />
            </Form.Item>
            <Form.Item
              name="isNews"
              label="Twórca Wiadomości terenowych"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item
              name="isActive"
              label="Widoczny na podstronie Przedstawiciele terenowi"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                  loading={isSaveButtonLoading}
                >
                  Zapisz
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </ConfigProvider>
      </div>
    </>
  );
};

export default RepresentativesAdd;
